import { VUE_UNION_STATION } from "@/assets/js/stationSetting";
export default function(language, path) {
  if (language == "en" && VUE_UNION_STATION == "8V") {
    return `/${path}`;
  } else {
    return `/${path}/${language}`;
  }
}
